module.exports = __webpack_public_path__ + "img/women.00a14c5e.webp";